import { render, staticRenderFns } from "./NoComment.vue?vue&type=template&id=ff06d070&scoped=true"
import script from "./NoComment.vue?vue&type=script&lang=js"
export * from "./NoComment.vue?vue&type=script&lang=js"
import style0 from "./NoComment.vue?vue&type=style&index=0&id=ff06d070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff06d070",
  null
  
)

export default component.exports